import type { DocumentState } from "@/types/documents";
import { formatDocumentState, getStateColorClasses } from "@/domains/documents/utils/documentState";
import { cn } from "@/lib/utils";

interface DocumentStateBadgeProps {
  /** Current document processing state */
  state?: DocumentState;
  /** Additional CSS classes */
  className?: string;
}

/**
 * DocumentStateBadge - Atom component
 *
 * Displays document processing state with color-coded badge.
 * Automatically shows animate-pulse for in-progress states.
 * Pure presentation component with no business logic.
 */
export function DocumentStateBadge({ state, className }: DocumentStateBadgeProps) {
  const displayText = formatDocumentState(state);
  const colorClasses = getStateColorClasses(state);

  return (
    <span
      className={cn(
        "inline-flex h-6 min-w-[100px] shrink-0 items-center justify-center rounded-full border px-2.5 text-xs font-semibold",
        colorClasses,
        className
      )}
    >
      {displayText}
    </span>
  );
}
